import axios from "../../axiosConfig/axios";

export const AddUser = {
    async EditContact(data) {
        return axios.patch(`user/contacts`,
         {
            "companyId": data?.companyId,
            "contacts": [{
                firstName:data?.contactdetail?.name,
                email:data?.contactdetail?.email,
                description:data?.contactdetail?.association,
                phoneNumber:data?.contactdetail?.phoneno,
                _id:data?.contactdetail?.id
            }]
         },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': data?.token
                }
            })

    },async importUser(data) {
        return axios.post(`user/contacts`,
         {
            "companyId": data?.companyId,
            "contacts": data?.contactdetail
         },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': data?.token
                }
            })

    },
    async addUser(data){
        return axios.post('user/contacts',{
            "companyId": data?.companyId,
            "contacts": [{
                firstName:data?.contactdetail?.name,
                email:data?.contactdetail?.email,
                description:data?.contactdetail?.association,
                phoneNumber:data?.contactdetail?.phoneno
            }],

        },{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': data?.token
            }
        })
    }
    ,
    async getUserContact(token,id){
        return axios.get(`user/contacts?companyId=${id}`,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        })
    },
    async fetchUserData(token) {
        return axios.get(`user`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })

    }
    ,
    async deleteContact(data){
        console.log(data)
        return axios.delete('user/contacts',{
            data:{
            "companyId": data?.companyId,
            "contact_id":data?.contact_id
            },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': data?.token
            }
        })
    }
}